import { iconDiscord } from '#src/atoms/icons/system/iconDiscord.ts';
import { iconFacebook } from '#src/atoms/icons/system/iconFacebook.ts';
import { iconInstagram } from '#src/atoms/icons/system/iconInstagram.ts';
import { iconReddit } from '#src/atoms/icons/system/iconReddit.ts';
import { iconTiktok } from '#src/atoms/icons/system/iconTiktok.ts';
import { iconTwitter } from '#src/atoms/icons/system/iconTwitter.ts';
import { iconYoutube } from '#src/atoms/icons/system/iconYoutube.ts';
import type { SocialLinkProps } from '#src/atoms/ui/SocialMedias/index.tsx';
import {
  DISCORD_INVITATION_URL,
  FACEBOOK_URL,
  INSTAGRAM_URL,
  MLB_DISCORD_INVITATION_URL,
  NBA_DISCORD_INVITATION_URL,
  REDDIT_URL,
  SUPPORT_TWITTER_URL,
  TIKTOK_URL,
  TWITTER_URL,
  US_FACEBOOK_URL,
  US_INSTAGRAM_URL,
  US_TWITTER_URL,
  YOUTUBE_URL,
} from '#src/constants/externalLinks.ts';

export const SocialLinksConfig: SocialLinkProps[] = [
  {
    icon: iconTwitter,
    social: 'x',
    links: [
      {
        label: '@Sorare',
        link: TWITTER_URL,
      },
      {
        label: '@SorareUS',
        link: US_TWITTER_URL,
      },
      {
        label: '@SorareSupport',
        link: SUPPORT_TWITTER_URL,
      },
    ],
  },
  {
    icon: iconFacebook,
    social: 'facebook',
    links: [
      {
        label: '@Sorare',
        link: FACEBOOK_URL,
      },
      {
        label: '@SorareUS',
        link: US_FACEBOOK_URL,
      },
    ],
  },
  {
    icon: iconInstagram,
    social: 'instagram',
    links: [
      {
        label: '@Sorare',
        link: INSTAGRAM_URL,
      },
      {
        label: '@SorareUS',
        link: US_INSTAGRAM_URL,
      },
    ],
  },
  {
    icon: iconDiscord,
    social: 'discord',
    links: [
      {
        label: 'Sorare Football',
        link: DISCORD_INVITATION_URL,
      },
      {
        label: 'Sorare MLB',
        link: MLB_DISCORD_INVITATION_URL,
      },
      {
        label: 'Sorare NBA',
        link: NBA_DISCORD_INVITATION_URL,
      },
    ],
  },
  {
    icon: iconReddit,
    social: 'reddit',
    links: [
      {
        label: 'Reddit',
        link: REDDIT_URL,
      },
    ],
  },
  {
    icon: iconYoutube,
    social: 'youtube',
    links: [
      {
        label: '@Sorare',
        link: YOUTUBE_URL,
      },
    ],
  },
  {
    icon: iconTiktok,
    social: 'tiktok',
    links: [
      {
        label: '@Sorare',
        link: TIKTOK_URL,
      },
    ],
  },
];
